import { Arrow } from "../styled";
import { ReactComponent as ArrowSvg } from "../assets/arrow.svg";

export function NextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <Arrow
      onClick={onClick}
      className={className}
      style={{ ...style, right: "-3%", top: "35%" }}
    >
      <ArrowSvg />
    </Arrow>
  );
}
